<div class="d-flex align-items-center gap-2 mb-2">
  <span class="label">{{ starLabel }}</span>

  <div class="progress-bar-container">
    <div class="h-100 bg-primary rounded" [style.width.%]="percentage"></div>
  </div>

  <span class="rating">({{ count }})</span>
</div>